import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";

import { Column } from "@rui/Stack";
import Switch, { SwitchProps } from "@rui/Switch";

export interface SettingSwitchProps {
  title: string;
  description: string;
  checked: SwitchProps["checked"];
  onChange: SwitchProps["onChange"];
}

const SettingSwitch = ({
  title,
  description,
  checked,
  onChange,
}: SettingSwitchProps) => (
  <FormControlLabel
    checked={checked}
    control={<Switch noMargin sx={{ mr: 2, mt: "1px" }} onChange={onChange} />}
    label={
      <Column spacing="2px">
        <Typography variant="bodyPrimaryMed" color="shades.neutral.700">
          {title}
        </Typography>
        <Typography variant="bodySecondaryReg" color="shades.neutral.500">
          {description}
        </Typography>
      </Column>
    }
    sx={{ m: 0, alignItems: "flex-start" }}
  />
);

export default SettingSwitch;
